/** Общее для готовых инструкций подключения агента (`agents.connection.instructions`
 *  в `ru/agents.ts` и `en/agents.ts`). Здесь только то, что не зависит от языка;
 *  тексты шагов живут в самих словарях, по одному цикла на язык. */

/** Адрес MCP-сервера платформы по адресу интерфейса Agent API.
 *
 *  Боевой адрес интерфейса — `<origin>/api/agent/v1`, а MCP-сервер — `<origin>/api/agent/mcp`
 *  (`app/api/agent_mcp.py`). Если адрес пришёл в другом виде, серверный путь
 *  просто дописывается к нему: так инструкция остаётся верной и на стенде. */
export function mcpAddress(base: string): string {
  const trimmed = base.replace(/\/+$/, "");
  return /\/api\/agent\/v1$/.test(trimmed)
    ? trimmed.replace(/\/v1$/, "/mcp")
    : `${trimmed}/api/agent/mcp`;
}

/** Готовый к вставке файл `mcp.json` для Cursor — `{"mcpServers": {"veil":
 *  {"url", "headers"}}}`. Адрес берётся тем же `mcpAddress`, что и в
 *  инструкции агенту: второго источника адреса MCP не заводится.
 *
 *  `key` — настоящий ключ, если интерфейс его знает (только что выдан), иначе
 *  слово-заполнитель, которое человек заменяет сам. Текст одинаков на обоих
 *  языках: это машинный конфиг, а не строка интерфейса. */
export function cursorMcpConfig(base: string, key: string): string {
  return JSON.stringify(
    {
      mcpServers: {
        veil: {
          url: mcpAddress(base),
          headers: { Authorization: `Bearer ${key}` },
        },
      },
    },
    null,
    2,
  );
}
